import React, { useRef, useState } from "react";
import "../components/app.scss";
import Logo from "../images/logo.svg";
import Banner from "../images/banner.svg";
import BannerImage from "../images/bg-tech.gif";
import CloseIcon from "../images/x.svg";

const Header = ({ scrollToSection }) => {
  const [isVideoVisible, setIsVideoVisible] = useState(false);
  const videoRef = useRef(null);

  const playVideo = () => {
    setIsVideoVisible(true);
    if (videoRef.current) {
      videoRef.current.contentWindow.postMessage(
        '{"event":"command","func":"playVideo","args":""}',
        "*"
      );
    }
  };

  const closeModal = () => {
    setIsVideoVisible(false);
  };



  return (
    <header className="app-header">
      {isVideoVisible && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close-btn"
                onClick={closeModal}
                aria-label="Close"
              >
                <img src={CloseIcon} alt="icon" />
              </button>
            </div>
            <div className="modal-body">
              {/* <iframe
                ref={videoRef}
                width="100%"
                height="550"
                src="https://www.youtube.com/embed/yLFyasGl3Ig?si=lsJ5TtVZT8X1RRxD"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe> */}
              <iframe  ref={videoRef}
                width="100%"
                height="550" src="https://www.youtube.com/embed/hTNKf7gc0Fc?si=Fvuamsc_Xd5hEtU9" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen>
              </iframe>
            </div>
          </div>
        </div>
      )}
      <img src={BannerImage} alt="banner" className="banner-video" />
      <div class="content">
        <div className="row">
          <div className="col-md-6 col-lg-6 offset-md-1 offset-lg-1 col-sm-12">
            <div className="description">
              <img src={Logo} alt="logo" className="img-fluid brand-logo" />
              <h1>Revolutionizing Secure Communication and Collaboration</h1>
              <div className="action-button-group">
                <button className="btn-primary"  onClick={scrollToSection}
                
                >
                  Key Features
                </button>
                <button className="btn-secondary" onClick={playVideo}>
                  Watch Video
                </button>
              </div>
            </div>
          </div>
          <div className="col-md-5 col-lg-5 col-sm-12 d-flex align-items-center justify-content-center flex-column">
            <img
              src={Banner}
              alt="logo"
              className="img-fluid banner-img"
              height={550}
              width={550}
            />
          </div>
          <div className="col-md-12 col-sm-12 col-lg-12">
            <div class="scrolling-text">
              <h2>
                Empowering the Modern World with Secure, Decentralized Solutions
              </h2>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
